// 🎨 هوية واجهة الشريك (ارت تاتش) - مبنية على هوية Artika الرسمية (أسود
// الحبر #141416 + خط Almarai "ArtikaFont") مع لمسة ذهبي شامباني مأخوذة من
// ألوان الإطارات نفسها. تصميم فقط - ما تمس أي منطق أو حساب.
import { createTheme } from "@mui/material/styles";

export const P = {
  ink: "#141416",
  ink2: "#2a2a2e",
  gold: "#b08d57",
  goldSoft: "#f4ece0",
  goldLine: "#e6d7bf",
  bg: "#f6f4f0",
  surface: "#ffffff",
  surface2: "#faf9f6",
  line: "#e9e6e0",
  lineStrong: "#d9d4ca",
  text: "#141416",
  muted: "#6e6b66",
  faint: "#a19c94",
  success: "#1f7a4d",
  successBg: "#e9f4ee",
  warning: "#9a6200",
  warningBg: "#fbf1de",
  danger: "#b3261e",
  dangerBg: "#fbeceb",
  font: '"ArtikaFont", "Almarai", "Segoe UI", Tahoma, sans-serif',
  radius: 14,
  shadow: "0 1px 2px rgba(20,20,22,.04), 0 8px 24px -12px rgba(20,20,22,.12)",
  shadowLg: "0 24px 48px -20px rgba(20,20,22,.28)",
};

export const iqd = (n) => `${Math.round(Number(n) || 0).toLocaleString("en-US")}`;

const partnerTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: P.ink, contrastText: "#fff" },
    secondary: { main: P.gold, contrastText: "#fff" },
    success: { main: P.success },
    error: { main: P.danger },
    warning: { main: P.warning },
    background: { default: P.bg, paper: P.surface },
    text: { primary: P.text, secondary: P.muted },
    divider: P.line,
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: P.font,
    button: { fontWeight: 700, textTransform: "none", letterSpacing: 0 },
    h4: { fontWeight: 800, letterSpacing: "-0.01em" },
    h5: { fontWeight: 800 },
    h6: { fontWeight: 800 },
  },
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { backgroundImage: "none" } },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { borderRadius: 12, paddingInline: 18, minHeight: 44 },
        sizeSmall: { minHeight: 34, borderRadius: 10, paddingInline: 12 },
        outlined: { borderColor: P.lineStrong, "&:hover": { borderColor: P.ink, background: P.surface2 } },
        containedPrimary: { "&:hover": { background: P.ink2 } },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          background: P.surface,
          "& .MuiOutlinedInput-notchedOutline": { borderColor: P.line },
          "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: P.lineStrong },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: P.ink, borderWidth: 1.5 },
        },
        input: { paddingTop: 14, paddingBottom: 14 },
        inputSizeSmall: { paddingTop: 10, paddingBottom: 10 },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: { paddingRight: "14px !important", paddingLeft: "40px !important" },
        icon: { right: "auto", left: 10, color: P.muted },
      },
    },
    // الاتجاه العربي: الدائرة يمين النص بمسافة صحيحة
    MuiFormControlLabel: {
      styleOverrides: { root: { marginLeft: 20, marginRight: -9 } },
    },
    MuiRadio: { styleOverrides: { root: { padding: 8 } } },
    MuiInputLabel: {
      styleOverrides: { root: { color: P.muted, "&.Mui-focused": { color: P.ink } } },
    },
    MuiFormHelperText: { styleOverrides: { root: { marginInline: 4, color: P.faint } } },
    MuiAlert: {
      styleOverrides: { root: { borderRadius: 12, fontWeight: 600, alignItems: "center" } },
    },
    MuiDialog: {
      styleOverrides: { paper: { borderRadius: 20, boxShadow: P.shadowLg } },
    },
    MuiDialogTitle: { styleOverrides: { root: { fontWeight: 800, fontSize: 19, paddingTop: 22 } } },
    MuiMenu: {
      styleOverrides: { paper: { borderRadius: 12, border: `1px solid ${P.line}`, boxShadow: P.shadowLg } },
    },
    MuiMenuItem: { styleOverrides: { root: { fontSize: 15, minHeight: 42 } } },
    MuiAvatar: { styleOverrides: { root: { fontFamily: P.font } } },
  },
});

export default partnerTheme;
